
interface CookieOptions {
  path?: string;
  secure?: boolean;
  sameSite?: 'strict' | 'lax' | 'none';
  expires?: Date;
}

// Test cookie functionality without setting persistent cookies
if (typeof window !== 'undefined') {
  setTimeout(() => {
    try {
      // Just log cookie functionality without creating persistent test cookies
      console.log('Cookie functionality test - current cookies:', document.cookie.split(';').length);
      
      // Check if we're in a Lovable preview
      const isLovablePreview = window.location.hostname.includes('lovable.dev');
      console.log(`Running in Lovable preview: ${isLovablePreview}`);
      
      // Log storage availability
      console.log('localStorage available:', typeof localStorage !== 'undefined');
      console.log('sessionStorage available:', typeof sessionStorage !== 'undefined');
    } catch (error) {
      console.error('Error testing cookies:', error);
    }
  }, 1000);
}

export const setCookie = (name: string, value: string, options: CookieOptions | number = 1) => {
  let cookieString = `${name}=${value}`;
  
  if (typeof options === 'number') {
    // Handle legacy number of days
    const date = new Date();
    date.setTime(date.getTime() + (options * 24 * 60 * 60 * 1000));
    cookieString += `;expires=${date.toUTCString()}`;
    cookieString += `;path=/`;
  } else {
    // Handle options object
    if (options.expires) {
      cookieString += `;expires=${options.expires.toUTCString()}`;
    }
    if (options.path) {
      cookieString += `;path=${options.path}`;
    }
    if (options.secure) {
      cookieString += `;secure`;
    }
    if (options.sameSite) {
      cookieString += `;samesite=${options.sameSite}`;
    }
  }

  try {
    // Add special tracking for problematic legacy cookies
    if (name === 'babblegram_game_completion_state' || name === 'babblegram_game_status') {
      console.error(`🚨 CREATING LEGACY COOKIE: ${name} = ${value}`);
      console.error('Stack trace:', new Error().stack);
    }
    
    document.cookie = cookieString;
    console.log(`Cookie set: ${cookieString}`);
  } catch (error) {
    console.error(`Error setting cookie ${name}:`, error);
    throw error; // Don't fallback to localStorage - fail explicitly for atomicity
  }
};

export const getCookie = (name: string): string | null => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  
  return null;
};

export const deleteCookie = (name: string) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
};

// Alias for backward compatibility
export const eraseCookie = deleteCookie;
